
var GalleryFilter = function () {
    this.GalleryKey                 = String;
    this.FieldName                  = String;
    this.FieldLabel                 = String;
    this.FieldDescription           = String;
    this.Sequence                   = Number;
    this.IsTypeAheadField           = Boolean;
    this.TypeAheadMinimumCharacters = Number;
    this.TypeAheadResultLimit       = String;
    this.DataType                   = String;
    this.IsRangeFilter              = Boolean;
    this.FixedFilterValues          = Object;
    this.RenderingType              = String;
    this.CascadeSet                 = String;
    this.CascadeSetSequence         = Number;
 //   this.Gottcha = String; // changes to db structure should trigger database delete and page refresh
}

module.exports = GalleryFilter;